export default __webpack_public_path__ + "static/media/new-corporate-icon.02a1be70.svg";